import { AgendaItem } from 'modules/jogador/agenda/types';
import { AGENDA_TYPE_LABELS } from 'modules/jogador/agenda/content';
import { Card } from 'shared/components/ui/Card';
import { Badge } from 'shared/components/ui/Badge';
import { Button } from 'shared/components/ui/Button';
import { cn } from 'shared/utils/cn';

const TYPE_TONE: Record<AgendaItem['type'], 'accent' | 'success' | 'warning'> = {
  jogo: 'accent',
  aula: 'success',
  torneio: 'warning',
};

interface AgendaItemCardProps {
  item: AgendaItem;
  isConfirming: boolean;
  onRequestCancel: (id: string) => void;
  onDismissCancel: () => void;
  onConfirmCancel: (id: string) => void;
}

export function AgendaItemCard({
  item,
  isConfirming,
  onRequestCancel,
  onDismissCancel,
  onConfirmCancel,
}: AgendaItemCardProps) {
  const isCancelled = item.status === 'cancelado';

  return (
    <Card className={cn('flex flex-col gap-3 p-4', isCancelled && 'opacity-60')}>
      <div className="flex items-center justify-between gap-3">
        <div>
          <Badge tone={TYPE_TONE[item.type]}>{AGENDA_TYPE_LABELS[item.type]}</Badge>
          <p className={cn('mt-2 font-medium text-ink', isCancelled && 'line-through')}>{item.title}</p>
          <p className="text-sm text-ink-secondary">{item.meta}</p>
        </div>
        <div className="text-right text-sm">
          <p className="font-medium text-ink">{item.dateLabel}</p>
          <p className="text-ink-secondary">{item.timeLabel}</p>
        </div>
      </div>

      {isCancelled ? (
        <Badge tone="danger" className="self-start">
          Cancelada
        </Badge>
      ) : isConfirming ? (
        <div className="flex items-center justify-between gap-2 rounded-lg bg-danger-soft px-3 py-2">
          <span className="text-xs text-danger">Cancelar esse compromisso?</span>
          <div className="flex gap-2">
            <Button variant="ghost" className="px-3 py-1 text-xs" onClick={onDismissCancel}>
              Voltar
            </Button>
            <Button
              className="bg-danger px-3 py-1 text-xs hover:bg-danger"
              onClick={() => onConfirmCancel(item.id)}
            >
              Confirmar cancelamento
            </Button>
          </div>
        </div>
      ) : (
        <div className="flex items-center justify-between">
          <p className="text-xs text-ink-secondary">{item.cancellationNote}</p>
          {item.cancellable && (
            <button
              type="button"
              onClick={() => onRequestCancel(item.id)}
              className="text-xs font-medium text-danger hover:underline"
            >
              Cancelar
            </button>
          )}
        </div>
      )}
    </Card>
  );
}
